import React, {Component} from 'react';

 
import axios from 'axios'; 
import {  Link } from 'react-router-dom'; 
import {api_base_url, base_url} from '../common/Constants'; 
import { SharedContext } from '../pages/createContext';

class Header extends Component {
    static contextType = SharedContext;
    constructor(){
        super();
        
        this.state = {
            posts : [],
            name:'Login',
            cart : [],
            loading:1,
            cartcount:0,
            settings:{},
            mobileMenu:"",
            searchPopup:"",
            searchWord:"",
            searchCategory:"all",
            subMenu:false,
            categories:[],
            sideMenu:"close",
            content: ""

        }
    }

    componentDidMount()
    { 
        
        const user_id =  localStorage.getItem('user_id');
        var data = { user_id : user_id}
 
        this.setState({posts:JSON.parse(localStorage.getItem("blogs"))}) ; 
        this.setState({content:JSON.parse(localStorage.getItem("content"))[0]}) ; 
        this.setState({settings:JSON.parse(localStorage.getItem("settings"))}) ; 
        this.setState({categories:JSON.parse(localStorage.getItem("categories"))}) ; 
        this.setState({cart:JSON.parse(localStorage.getItem("cart"))}) ; 
        this.setState({name:(JSON.parse(localStorage.getItem("user")) == "" ? "Login" : JSON.parse(localStorage.getItem("user")).name)});
        this.setState({loading:0}); 
        this.setState({cartload:0});  
        this.setState({cartcount:JSON.parse(localStorage.getItem("cart")).cart.length}) ; 

        
        const script = document.createElement("script");
                    script.src   = base_url+"assets/js/loadMenu.js";  
                    script.async = true;
                    document.body.appendChild(script);
         
                    script.onload = () => {
                    if (window.loadMobileMenu()  ) {
                    window.loadMobileMenu()();
                    this.setState({loading:1})
                    }
                    };
         
    }

    handleSubmit = (event) => {
    event.preventDefault(); 
    window.location.href = '#/search/'+this.state.searchCategory+"/"+this.state.searchWord;
  };
    handleSideMenuOpen = (event) => {
        this.setState({sideMenu:"open"});
     }

    handleSideMenuClose = (event) => {
            this.setState({sideMenu:"close"});
        }


    handleMobileMenu = (event) => {
        this.setState({mobileMenu:"expanded"});
     }

    handleMobileMenuClose= (event) => {
        this.setState({mobileMenu:""});
    }
     
    handleSearchBox = (event) => {
        this.setState({searchPopup:"active"});
     }

     handleSearchBoxClose= (event) => {
        this.setState({searchPopup:""});
    }
     
    handleSearch= (event) => {
       // this.setState({searchPopup:""});
    }
     
    handleSearchWord= (event) => {
        this.setState({searchWord:event.target.value});
    }
    handleSearchCategory= (event) => {
        this.setState({searchCategory:event.target.value});
    }
    menuClickHandler= (event) => {
        this.setState({mobileMenu: false});
       }
    subMenuHandler= (event) => {
        if(this.state.subMenu)
        {
            this.setState({subMenu: false});
        }
        else{
            this.setState({subMenu: true});
        }
        
    }
                
    render()
    {
         const { searchCategory, searchWord } = this.state;
    const searchUrl = base_url+`search/${encodeURIComponent(searchCategory)}/${encodeURIComponent(searchWord)}`;


  return (
    <div>

<div className={ this.state.sideMenu == "open" ? "ul-sidebar active" : "ul-sidebar" }>
        
        <div className="ul-sidebar-header">
            <div className="ul-sidebar-header-logo">
                <Link to="/">
                            <img src={base_url+"assets/img/kloth.jpg"} alt={this.state.settings.site_title} className="logo"  />
                        </Link>
               
            </div>
             
            <button className="ul-sidebar-closer" onClick={this.handleSideMenuClose}><i className="flaticon-close"></i></button>
        </div>

        <div className="ul-sidebar-header-nav-wrapper d-block d-lg-none"></div>

        <div className="ul-sidebar-about d-none d-lg-block">
            <span className="title">About Kloth Fashion Store</span>
            <p className="mb-0"><div dangerouslySetInnerHTML={{ __html: this.state.content.body}} /></p>
        </div>

 
 
 
        <div className="ul-sidebar-footer">
            <span className="ul-sidebar-footer-title">Follow us</span>

            <div className="ul-sidebar-footer-social">
               <Link to={this.state.settings.site_facebook_url}  target="_blank"><i className="flaticon-facebook-app-symbol"></i></Link>
               <Link to={this.state.settings.site_instagram_url}  target="_blank"><i className="flaticon-instagram"></i></Link>
               <Link to={this.state.settings.site_youtube_url} aria-hidden="true" target="_blank"><i className="flaticon-youtube"></i></Link>
            </div>
        </div>
    </div>
     <header class="ul-header">
       
        <div class="ul-header-top">
            <div class="ul-header-top-slider splide">
                <div class="splide__track">
                    <ul class="splide__list">
                        <li class="splide__slide">
                            <p class="ul-header-top-slider-item"><i class="flaticon-sparkle"></i> limited time offer</p>
                        </li>
                        <li class="splide__slide">
                            <p class="ul-header-top-slider-item"><i class="flaticon-sparkle"></i> limited time offer</p>
                        </li>
                        <li class="splide__slide">
                            <p class="ul-header-top-slider-item"><i class="flaticon-sparkle"></i> limited time offer</p>
                        </li>
                        <li class="splide__slide">
                            <p class="ul-header-top-slider-item"><i class="flaticon-sparkle"></i> limited time offer</p>
                        </li>
                        <li class="splide__slide">
                            <p class="ul-header-top-slider-item"><i class="flaticon-sparkle"></i> limited time offer</p>
                        </li>
                        <li class="splide__slide">
                            <p class="ul-header-top-slider-item"><i class="flaticon-sparkle"></i> limited time offer</p>
                        </li>
                        <li class="splide__slide">
                            <p class="ul-header-top-slider-item"><i class="flaticon-sparkle"></i> limited time offer</p>
                        </li>
                        <li class="splide__slide">
                            <p class="ul-header-top-slider-item"><i class="flaticon-sparkle"></i> limited time offer</p>
                        </li>
                        <li class="splide__slide">
                            <p class="ul-header-top-slider-item"><i class="flaticon-sparkle"></i> limited time offer</p>
                        </li>
                        <li class="splide__slide">
                            <p class="ul-header-top-slider-item"><i class="flaticon-sparkle"></i> limited time offer</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        
        <div class="ul-header-bottom">
            <div class="ul-container">
                <div class="ul-header-bottom-wrapper">
                     
                    <div class="header-bottom-left">
                        <div class="logo-container">
                            <Link to="/" class="d-inline-block"><img src={base_url +"assets/img/kloth.jpg" } alt="logo" class="logo" /> </Link>
                        </div>

                         
                        <div class="ul-header-search-form-wrapper flex-grow-1 flex-shrink-0">
                            <form action="#" class="ul-header-search-form"  onSubmit={this.handleSubmit}>
                                <div class="dropdown-wrapper">
                                    <select name="search-category" id="ul-header-search-category"  onChange={this.handleSearchCategory}>
                                        <option data-placeholder="true">Select Category</option>
                                        {this.state.categories.map((item,key)=>{
                                                    return item.parent_id ===null ? <option  value={`${item.slug}`} >{item.name}</option> : "";
                                                })}
                                         
                                    </select>
                                </div>
                                <div class="ul-header-search-form-right">
                                    <input type="search" name="header-search" id="ul-header-search" onChange={this.handleSearchWord} placeholder="Search Here" />
                                    <Link to={searchUrl} ><button type="button" ><span class="icon"><i class="flaticon-search-interface-symbol"></i></span></button></Link>
                                </div>
                            </form>

                            <button class="ul-header-mobile-search-closer d-xxl-none"><i class="flaticon-close"></i></button>
                        </div>
                    </div>

                     
                    <div class="ul-header-nav-wrapper">
                        <div class="to-go-to-sidebar-in-mobile">
                            <nav class="ul-header-nav">
                                <Link to="/">Home</Link>
                                <Link to={base_url+"about-us"}>About</Link>
                                {this.state.categories.map((item,key)=>{
                                                    return item.parent_id === null ? <Link  to={base_url+`category/${item.slug}`} >{item.name}</Link> : "";
                                                })}
                                   
                                   
                                <Link to={base_url+"contact-us"}>Contact Us</Link>

                            </nav>
                        </div>
                    </div>

                    
                    <div class="ul-header-actions">
                        <button class="ul-header-mobile-search-opener d-xxl-none"><i class="flaticon-search-interface-symbol"></i></button>
                        <Link  to={this.state.name == "Login" ? base_url+"user/login" : base_url+"user/profile"}  ><i class="flaticon-user"></i> </Link>
                        {/*****<a href="wishlist.html"><i class="flaticon-heart"></i></a>***/}
                        <Link to="/cart"><i class="flaticon-shopping-bag"></i>
                        <span className={this.props.cartpage  ? 'cart-count dblock' : 'cart-count dnone' }  >{this.context.sharedState}</span>
                        <span className={!this.props.cartpage ? 'cart-count dblock' : 'cart-count dnone' }  >{this.state.cartcount}</span>
                        </Link>
                    </div>
                    <div class="d-inline-flex">
                        <button class="ul-header-sidebar-opener"  onClick={this.handleSideMenuOpen}><i class="flaticon-hamburger"></i></button>
                    </div>

                    
                    
                </div>
            </div>
        </div>
    </header>
         
        
    </div>
   
    
  );
}
};

 
export default Header; 